module.exports = __webpack_public_path__ + "static/media/9DESA35.15d601d7.jpg";